export default {
  state: {
    departmentSelectList: [], // 部门
    postList: [] // 岗位列表
  },
  mutations: {
    setDepartmentSelectList (state, list) { // 部门
      state.departmentSelectList = list
    },
    setPostList (state, list) { // 岗位列表
      state.postList = list
    }
  },
  getters: {
  },
  actions: {
    getDepartmentSelectList ({ state, commit }, list) { // 部门
      commit('setDepartmentSelectList', list)
    },
    getPostList ({ state, commit }, list) { // 岗位列表
      commit('setPostList', list)
    }
  }
}
